import { createAsyncThunk } from "infrastructure/store/lib";
import type { AsyncThunk, RootState } from "infrastructure/store";
import { ApiState } from "infrastructure/api";
import type { ThunkReturnType } from "types";
import { ApiRouteTypes } from "consts/enpoints/api";
import { payloadCreator } from "util/api";
import { concat } from "util/support";
import { getManualBulkKYCsImportHistory } from "features/kyc/api";
import { sliceToken } from "./state";
import type { ManualBulkKYCsImportHistoryResponse } from "./types";

export const getManualBulkKYCsImportHistoryThunk: AsyncThunk<
    ThunkReturnType<ManualBulkKYCsImportHistoryResponse>,
    string | undefined,
    {}
> = createAsyncThunk(
    concat([sliceToken, ApiRouteTypes.GetManualBulkKYCsImportHistory]),
    payloadCreator(getManualBulkKYCsImportHistory),
    {
        condition: (_, { getState }) => {
            const { kyc } = getState() as RootState;

            return ![ApiState.Pending].includes(kyc.tableLoadingState);
        }
    }
);
